export default __webpack_public_path__ + "media/images/logo_full-ae4b79a4d8ac12afe68ab1ba1103cd02.svg";